import {Heading} from "../../ui-components/heading.tsx";
import {Text} from "../../ui-components/text.tsx";
import styles from "./NotFound.module.scss";
import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";

export const NotFoundPage = () => {

    const {t} = useTranslation();

    return (
        <div className={styles.Wrapper}>
            <Heading className={"text-[22px] text-white-500 font-sarabun  font-bold mb-5"}
                     color={"white"}>
                {t('pages.notFound.title')}
            </Heading>
            <Text className={"!text-sm text-[var(--color-desc)] mb-3"}>
                {t('pages.notFound.subTitle')}
            </Text>
            <NavLink to={import.meta.env.VITE_APP_BOT_LINK} className={"!text-sm text-[var(--color-desc)] underline"}>
                {t('pages.notFound.openBotBtn')}
            </NavLink>
        </div>
    )
}